module.exports = __webpack_public_path__ + "static/img/26827.7b221aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/stockUniverse/26827.png
// module id = gN4I
// module chunks = 0